interface LabelData {
  x: number;
  y: number;
  size: number;
  label?: string;
}
interface HoverData {
  x: number;
  y: number;
  size: number;
  label?: string;
  color?: string;
}
interface LabelSettings {
  labelSize: number;
  labelFont: string;
  labelWeight: string;
}

export function drawSigmaNodeLabel(
  ctx: CanvasRenderingContext2D,
  data: LabelData,
  settings: LabelSettings,
): void {
  const { label, x, y, size } = data;
  if (!label) return;
  const fs = settings.labelSize;
  ctx.font = `${settings.labelWeight} ${fs}px ${settings.labelFont}`;
  const tw = ctx.measureText(label).width;
  const tx = x + size + 3;
  const ty = y + fs * 0.35;
  ctx.fillStyle = 'rgba(6,6,10,0.82)';
  ctx.fillRect(tx - 2, y - fs * 0.6, tw + 6, fs + 4);
  ctx.fillStyle = '#ffffff';
  ctx.fillText(label, tx, ty);
}

export function drawSigmaNodeHover(
  ctx: CanvasRenderingContext2D,
  data: HoverData,
  settings: LabelSettings,
): void {
  const { x, y, size, label } = data;
  const fs = settings.labelSize;
  const PADDING = 2;

  ctx.font = `${settings.labelWeight} ${fs}px ${settings.labelFont}`;
  ctx.fillStyle = 'rgba(30,8,60,0.96)';
  ctx.shadowOffsetX = 0;
  ctx.shadowOffsetY = 0;
  ctx.shadowBlur = 8;
  ctx.shadowColor = '#7c3aed';

  if (typeof label === 'string') {
    const textWidth = ctx.measureText(label).width;
    const boxWidth = Math.round(textWidth + 5);
    const boxHeight = Math.round(fs + 2 * PADDING);
    const radius = Math.max(size, fs / 2) + PADDING;
    const angleRadian = Math.asin(boxHeight / 2 / radius);
    const xDeltaCoord = Math.sqrt(Math.abs(radius ** 2 - (boxHeight / 2) ** 2));
    ctx.beginPath();
    ctx.moveTo(x + xDeltaCoord, y + boxHeight / 2);
    ctx.lineTo(x + radius + boxWidth, y + boxHeight / 2);
    ctx.lineTo(x + radius + boxWidth, y - boxHeight / 2);
    ctx.lineTo(x + xDeltaCoord, y - boxHeight / 2);
    ctx.arc(x, y, radius, angleRadian, -angleRadian);
    ctx.closePath();
    ctx.fill();
  } else {
    ctx.beginPath();
    ctx.arc(x, y, size + PADDING, 0, Math.PI * 2);
    ctx.closePath();
    ctx.fill();
  }

  ctx.shadowOffsetX = 0;
  ctx.shadowOffsetY = 0;
  ctx.shadowBlur = 0;

  if (typeof label === 'string') {
    const radius = Math.max(size, fs / 2) + PADDING;
    ctx.fillStyle = '#ffffff';
    ctx.fillText(label, x + radius + 3, y + fs * 0.35);
  }
}
